<template>
  <div :id="id" style="height:31rem;width:100%"></div>
</template>

<script>
import { getUUID } from '@/utils/util'
let map = null
let panorama = null
let unwatch = null

export default {
  name: 'BaiDuMap',
  data () {
    return {
      map: null,
      id: getUUID(),
      panorama: null
    }
  },
  props: {
    chooseCoordinates: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    map = new BMap.Map(this.id)
    panorama = new BMap.Panorama(this.id)
    panorama.setPov({ heading: 0, pitch: 6 })
    map.addTileLayer(new BMap.PanoramaCoverageLayer())
    unwatch = this.$watch(
      'realchooseCoordinates',
      function (newv, oldv) {
        if (newv.length > 0) {
          this.setData(newv)
        }
      },
      { deep: true, immediate: true }
    )
  },
  beforeDestroy () {
    console.log('ss')
    if (unwatch) {
      unwatch()
      unwatch = null
    }
  },
  computed: {
    realchooseCoordinates () {
      return this.chooseCoordinates ? [...this.chooseCoordinates] : []
    }
  },
  methods: {
    setData (v) {
      console.log('setData-BMap', v)
      map.centerAndZoom(new BMap.Point(v[0], v[1]), 15)
      panorama.setPosition(new BMap.Point(v[0], v[1]))
    }
  }
}
</script>
